export default "<div class=\"{{form.htmlClass}}\">\r\n\t<schema-markdown content=\"form.markdown\" variant=\"form.variant\"></schema-markdown>\r\n</div>\r\n";